import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { use, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import usePrivileges from "../../../../../Auth/usePrivileges";
import { LotDetailContext } from "../../../../../Contexts/LotDetailContext";
import EditRFTCodeDialog from "../../../../../Dialogs/EditRFTCodeDialog";

export function RFTCodeField() {
    const { t } = useTranslation();
    const {
        lotDetail: {
            summary: {
                businessUnitCode,
                data: {
                    rftCode
                }
            }
        },
    } = use(LotDetailContext);
    const [showEditRFTCodeDialog, setShowEditRFTCodeDialog] = useState(false);
    const { canReview, canGrade, admin } = usePrivileges(businessUnitCode);

    return (
        <Form.Group as={Col} sm={6} controlId="formRFTCode">
            <Row>
                <Form.Label column sm={4}>{t('LotDetails.Summary.RFTCode')}:</Form.Label>
                <Col sm={8}>
                    <div className="d-flex justify-content-start">
                        <Form.Control type="text" disabled value={rftCode ?? ""} />
                        <Button variant="light" hidden={!admin && !canGrade && !canReview} className="ms-2" onClick={() => setShowEditRFTCodeDialog(true)} >
                            <FontAwesomeIcon icon={faEllipsis} />
                        </Button>
                    </div>
                </Col>
            </Row>
            <EditRFTCodeDialog showDialog={showEditRFTCodeDialog} closeDialog={() => setShowEditRFTCodeDialog(false)} />
        </Form.Group>
    );
}